<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="tableMap.length>0">
    <book-info-modal ref="bookInfoModal" :bookDto="bookDtoData" :bookCovers="bookCoversObj"></book-info-modal>

    <b-container fluid>
      <small>
        <b-table head-variant="light"
                 small
                 bordered
                 hover
                 ref="table"
                 :items="tableMap"
                 :fields="fields">

          <div class="loading-parent">
            <loading :active.sync="isLoading"
                     :is-full-page="fullPage"></loading>
          </div>

          <template slot="bookTitle" slot-scope="data">
            <a href="#" @click="getBook(data.item.bookId)">
              {{data.item.bookTitle}}
            </a>
          </template>

          <template slot="amount" slot-scope="data">
            <input v-model="data.item.amount" type="number"/>
          </template>

          <template slot="action" slot-scope="data">
            <b-button size="sm" variant="secondary" @click="updateAvailable(data)">Ενημέρωση</b-button>
          </template>
        </b-table>
      </small>
    </b-container>
  </div>
</template>

<script>

  import requests, {GlobalEudoxusBus} from '../../js/DistributionRequestService';
  import BookInfoModal from '../BookDeliveryTabComponents/BookInfoModalComponent';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';

  export default {
    name: "availability-list-component",
    data() {
      return {
        isLoading: false,
        fullPage: true,
        selected: null,
        current: null,
        bookDtoData: '',
        bookCoversObj: {},
        fields: [
          {key: 'bookId', label: 'Κωδικός', sortable: true, 'class': 'text-left'},
          {key: 'bookTitle', label: 'Βιβλία', sortable: true, 'class': 'text-left'},
          {key: 'bookTotal', label: 'Διαθεσιμότητα', sortable: true, 'class': 'text-left'},
          {key: 'amount', label: 'Μεταβολή', 'class': 'text-left'},
          {key: 'action', label: 'Ενημέρωση', 'class': 'text-center'}
        ],
        tableMap: []
      }
    },
    components: {
      'loading': Loading,
      'bookInfoModal': BookInfoModal
    },
    methods: {
      updateAvailable(data) {
        this.isLoading = true;
        if (data.item.amount != null) {
          requests.updateBookAvailability(requests.getDistributionPointId(), data.item.bookId, this.selected, data.item.amount, data, this.reloadData);
        } else {
          this.isLoading = false;
          alert("Παρακαλώ εισάγετε νέο έγκυρο ποσό");
        }
      },
      getBook(bookId) {
        requests.getBook(Number(bookId), this.bookInfoModal);
      },
      bookInfoModal(bookDto) {
        this.bookDtoData = bookDto;
        let fullPath = "https://static.eudoxus.gr/books/";
        let coverPathImg = fullPath + this.bookDtoData.pathToCover;
        let backCoverPathImg = this.bookDtoData.pathToBackcover;
        this.bookCoversObj = {frontCover: coverPathImg, backCover: backCoverPathImg};

        GlobalEudoxusBus.$emit('toggleBookInfoModal', true);
      },
      reloadData(data, result) {
        if (data != null && result != null) {
          data.item.bookTotal = result.total;
          data.item.amount = null;
        }
        this.isLoading = false;
      },
    },
    created() {
      GlobalEudoxusBus.$on('availabilityTableSetup', tableMap => {
        this.tableMap = tableMap;
        if (this.tableMap.length !== 0)
          this.selected = this.tableMap[0].selectedYear;
      });
    }
  }
</script>

<style scoped>
  .loading-parent {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/AvailabilityTabComponents/AvailabilityListComponent.vue